import baseColors from './colors'

const breakpoints = [
  32,
  48,
  64,
  80
].map(n => n + 'em')

const space = [
  0,
  4,
  8,
  16,
  32,
  64,
  128
]

const fontSizes = [
  12,
  14,
  16,
  20,
  24,
  32,
  48,
  64,
  72,
  96
]

const fontWeights = {
  normal: 400,
  bold: 700
}

const radii = [0, 2, 4]

const fonts = {
  0: 'Open Sans, sans-serif',
  sans: 'Open Sans, sans-serif',
  mono: '"SF Mono", "Roboto Mono", Menlo, monospace'
}

const shadows = [
  'none',
  `inset 0 0 0 1px ${baseColors.gray}`,
  `inset 0 0 0 1px ${baseColors.gray}, 0 0 4px ${baseColors.gray}`,
  '2px 2px 8px 0 rgba(0,0,0,.2)'
]

const colors = {
  ...baseColors,
  primary: '#e86161',
  secondary: '#155d89',
  error: '#c12e1e',
  disabled: '#b4b4b4',
  text: '#202b3d',
  lightText: '#9198a0',
  highlight: '#fafafa',
  accent1: '#e86161',
  accent2: '#f9bc99',
  accent3: '#eede91',
  accent4: '#97dbe6',
  accent5: '#155d89'
}

export default {
  breakpoints,
  space,
  fontSizes,
  fontWeights,
  fonts,
  colors,
  radii,
  shadows
}


// WEBPACK FOOTER //
// ./src/constants/theme.js